export const scrollToTop = function () {
    let elem = document.getElementsByClassName('header-hamburger')[0];
    elem && elem.scrollIntoView({behavior: "smooth"});
    if (!elem) {
        let elem2 = document.getElementsByClassName('layout-secondary')[0];
        elem2 && elem2.scrollIntoView({behavior: "smooth"});
        if (!elem2) {
            let elem2 = document.getElementsByClassName('layout-assessor')[0];
            elem2 && elem2.scrollIntoView({behavior: "smooth"});
        }
    }
    let elem3 = document.getElementsByClassName('iat-mobile')[0];
    elem3 && elem3.scrollIntoView({behavior: "smooth"});
};
